export enum TimeSpanType {
  ONE_DAY = 'one-day',
  ONE_WEEK = 'one-week',
  ONE_MONTH = 'one-month',
  SIX_MONTHS = 'six-months',
  TWELVE_MONTHS = 'twelve-months',
  ALL_TIME = 'all-time',
  RANGE = 'range',
}
export interface TimeSpanDropdownItem {
  name: string;
  value: TimeSpanType;
}
